import { WeatherMoon, WeatherSunny } from "@/coral/imports/bundleicons";
import { useTheme } from "@/ThemeContext";
import { Body1Strong, Button, Tooltip } from "@fluentui/react-components";
import React, { ReactNode } from "react";

interface ContentToolbarProps {
  panelIcon?: ReactNode;
  panelTitle?: string | null;
  children?: ReactNode;
}

const ContentToolbar: React.FC<ContentToolbarProps> = ({
  panelIcon,
  panelTitle,
  children,
}) => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <div
      className="panelToolbar"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "16px",
        boxSizing: "border-box",
        height: "56px",
      }}
    >
      {(panelIcon || panelTitle) && (
        <div
          className="panelTitle"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            flex: "1 1 auto",
            overflow: "hidden",
          }}
        >
          {panelIcon && (
            <div
              style={{
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
              }}
            >
              {panelIcon}
            </div>
          )}
          {panelTitle && (
            <Body1Strong
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {panelTitle}
            </Body1Strong>
          )}
        </div>
      )}
      <div
        className="panelTools"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0",
        }}
      >
        {children}
        <Tooltip
          content={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
          relationship="label"
        >
          <Button
            appearance="subtle"
            icon={isDarkMode ? <WeatherSunny /> : <WeatherMoon />}
            onClick={toggleTheme}
            aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
          />
        </Tooltip>
      </div>
    </div>
  );
};

export default ContentToolbar;
